import { Box, Card, Typography } from "@mui/material";

interface UsersCountSummaryProps {
	title: string;
	total: number | string;
	icon?: string;
	color?: string;
	sx?: any;
}

export default function UsersCountSummary({ title, total, icon, color = "primary", sx, ...other }: UsersCountSummaryProps) {
	return (
		<Card
			sx={{
				py: 2,
				px: 2,
				boxShadow: 0,
				textAlign: "center",
				color: (theme: any) => theme.palette[color].darker,
				bgcolor: (theme: any) => theme.palette[color].lighter,
				...sx,
			}}
			{...other}
		>
			<Typography variant="h5">
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: 1,
					}}
				>
					{icon && (
						<Box
							component="img"
							src={icon}
							sx={{
								width: 18,
								height: 18,
							}}
							alt=""
						/>
					)}
					{total}
				</Box>
			</Typography>

			<Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize: "0.875rem", fontWeight: 600 }}>
				{title}
			</Typography>
		</Card>
	);
}
